/** InsCoder WANG.J 2026-02-01 B + M2 Subscription Section Scripts **/

(function() {
  'use strict';

  // Success Popup elements
  var popupOverlay = null;
  var popup = null;
  var closeBtn = null;

  /**
   * Initialize popup elements
   */
  function initPopupElements() {
    var section = document.querySelector('.cust-m2-subscription');
    if (!section) return false;

    popupOverlay = section.querySelector('.cust-m2-subscription__popup-overlay');
    popup = section.querySelector('.cust-m2-subscription__popup');
    closeBtn = section.querySelector('.cust-m2-subscription__popup-close');

    if (!popupOverlay || !popup) return false;

    if (closeBtn) {
      closeBtn.addEventListener('click', closePopup);
    }
    popupOverlay.addEventListener('click', closePopup);

    // Close success popup when jumping to Terms link (e.g. #tc)
    var termsLinks = section.querySelectorAll('.cust-m2-subscription__popup-terms-link[href]');
    termsLinks.forEach(function(link) {
      link.addEventListener('click', function() {
        closePopup();
      });
    });

    var escHandlerBound = false;

    function handleEscKey(e) {
      if (e.key === 'Escape' && popup && popup.classList.contains('is-active')) {
        closePopup();
      }
    }

    if (!escHandlerBound) {
      document.addEventListener('keydown', handleEscKey);
      escHandlerBound = true;
    }

    return true;
  }

  /**
   * Open the success popup
   */
  function openPopup() {
    if (!popupOverlay || !popup) return;

    popupOverlay.classList.add('is-active');
    popup.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  /**
   * Close the success popup
   */
  function closePopup() {
    if (!popupOverlay || !popup) return;

    popupOverlay.classList.remove('is-active');
    popup.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  /**
   * Watch for Form Builder initialization
   * Monitors for form.g-container element and binds form events
   */
  function initFormWatcher() {
    var formContainer = document.querySelector('.cust-m2-subscription');
    if (!formContainer) return;

    initPopupElements();

    var existingForm = formContainer.querySelector('form.g-container');
    if (existingForm) {
      bindFormEvents(existingForm);
      return;
    }

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (checkForFormContainer(node)) {
                observer.disconnect();
              }
            }
          });
        }
      });
    });

    observer.observe(formContainer, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Check if the node is or contains form.g-container
   * @param {Node} node - DOM node to check
   */
  function checkForFormContainer(node) {
    var form = null;

    if (node.matches && node.matches('form.g-container')) {
      form = node;
    } else if (node.querySelector) {
      form = node.querySelector('form.g-container');
    }

    if (form) {
      bindFormEvents(form);
      return true;
    }
    return false;
  }

  /**
   * Bind popup and subscription tracking events to the form
   * @param {HTMLFormElement} form - Form element
   */
  function bindFormEvents(form) {
    if (form.dataset.custM2EventsBound) return;
    form.dataset.custM2EventsBound = 'true';

    form.addEventListener('reset', function() {
      openPopup();
    });

    document.addEventListener('globo.formbuilder.form.submitted', function(event) {
      if (!event.detail || event.detail.form !== form) return;
      if (typeof window.pushSubscribeUaEvent !== 'function') return;

      var trackingRoot = form.closest('[data-subscribe-tracking]') || form;

      window.pushSubscribeUaEvent('subscribe_success', {
        root: trackingRoot,
        buttonName: 'Submit',
        moduleName: trackingRoot.dataset.moduleName,
        entryName: trackingRoot.dataset.entryName,
        status: 'success'
      });
    });
  }

  window.CustM2Subscription = {
    openPopup: openPopup,
    closePopup: closePopup
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFormWatcher);
  } else {
    initFormWatcher();
  }

})();

/** InsCoder WANG.J 2026-02-01 E + M2 Subscription Section Scripts **/
